import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { SelectChangeEvent } from "@mui/material/Select";
import { appBarStyles } from "./toolbarstyle";
// import { textStyle } from "src/styles/textstyle";
import { Link as ScrollLink } from "react-scroll";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import SignupModal from "../modals/SignUpModal";
import { getIsSignedIn } from "src/redux/reducers/user";
import HamburgerMenu from "./hamburgermenu";
import FindHomesModal from "../modals/FindHomesModal";
import { backgroundColor } from "src/styles/mainstyle";
import { useMediaQuery, useTheme } from "@mui/material";
import MainButton from "../buttons/mainbutton";
import SecondaryButton from "../buttons/secondbutton";
const logo = process.env.PUBLIC_URL + "/hslogo_transparent.png";

type HeaderProps = {};

export default function Header({}: HeaderProps) {
  // import dotenv from "dotenv";
  // dotenv.config();
  const mobileTheme = useTheme();
  const isDesktop = useMediaQuery(mobileTheme.breakpoints.down("sm"));
  const [language, setLanguage] = React.useState<string>("en");
  // const [openLoginModal, setLoginModal] = useState(false);
  const [openSignUpModal, setSignUpModal] = useState(false);
  const [openFindHomesModal, setOpenFindHomesModal] = useState(false);
  const isSignedIn = getIsSignedIn();
  const navigate = useNavigate();

  const handleLanguageChange = (event: SelectChangeEvent<string>) => {
    setLanguage(event.target.value);
  };
  return (
    <AppBar position="fixed" sx={appBarStyles}>
      <Box
        sx={{
          position: "fixed",
          top: 0,
          width: "100%",
          ...appBarStyles,
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <RouterLink to="/" style={{ textDecoration: "none" }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <img
                src={logo}
                alt="HomeSwap Logo"
                style={{
                  height: "1.5rem",
                  width: "auto",
                  paddingRight: "10px",
                }}
              />
            </Box>
          </RouterLink>

          {isSignedIn ? (
            <Box
              sx={{ display: "flex", justifyContent: "center", width: "auto" }}
            >
              <MainButton
                text={"Find Homes"}
                onClick={() => setOpenFindHomesModal(true)}
              />
              <Box sx={{ width: 32 }} />{" "}
              {/* This creates some space between the items */}
              {!isDesktop && (
                <SecondaryButton
                  text={"Favourites"}
                  onClick={() =>
                    navigate(
                      `/homes?search=${encodeURIComponent(JSON.stringify({ liked: true }))}`,
                    )
                  }
                />
              )}
              {/* <Box sx={{ width: 32 }} />{" "} */}
              {/* This creates some space between the items */}
              {/* <HeaderLink text={"Notifications"} /> */}
            </Box>
          ) : (
            <Box
              sx={{ display: "flex", justifyContent: "center", width: "auto" }}
            >
              <MainButton text="Sign up" onClick={() => setSignUpModal(true)} />
              <Box sx={{ width: 32 }} />{" "}
              {!isDesktop && (
                <>
                  <ScrollLink
                    to="how-it-works" // the id of the element you want to scroll to
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}
                  >
                    <SecondaryButton
                      text="How it works"
                      // onClick={() => {}}
                    />
                  </ScrollLink>
                  <Box sx={{ width: 32 }} />{" "}
                </>
              )}
              {/* This creates some space between the items */}
              {/* This creates some space between the items */}
              {!isDesktop && (
                <SecondaryButton
                  text="Log in"
                  onClick={() => setSignUpModal(true)}
                />
              )}
            </Box>
          )}
          <HamburgerMenu />

          {/* <Select
            value={language}
            onChange={handleLanguageChange}
            sx={{
              ...textStyle,
              "&:focus": {
                outline: "none",
              },
              "& .Mui-focused": {
                outline: "none",
              },
              "&.Mui-focusVisible": {
                outline: "none",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
              },
            }}
          >
            <MenuItem value={"en"}>English</MenuItem>
            <MenuItem value={"es"}>Spanish</MenuItem>
            {/* Add more languages as needed */}
          {/* </Select>  */}
        </Toolbar>
      </Box>
      {/* <LoginModal
        open={openLoginModal}
        onClose={() => setLoginModal(false)}
        openSignup={() => setSignUpModal(true)}
      /> */}
      <SignupModal
        open={openSignUpModal}
        onClose={() => setSignUpModal(false)}
      />
      <FindHomesModal
        open={openFindHomesModal}
        onClose={() => setOpenFindHomesModal(false)}
      />
    </AppBar>
  );
}

type HeaderLinkProps = {
  onClick?: () => void;
  text: string;
  footerLink?: boolean;
};

export function HeaderLink({ text, onClick, footerLink }: HeaderLinkProps) {
  return (
    <Typography
      variant={footerLink ? "h4" : "h6"}
      component="div"
      sx={{
        fontWeight: footerLink ? "bold" : "normal",
        color: footerLink ? backgroundColor : "black",
        "&:hover": {
          textDecoration: "underline",
        },
      }}
      onClick={onClick}
    >
      {text}
    </Typography>
  );
}
